export default __webpack_public_path__ + "static/media/language.1903d86b.jpg";